import { UnitTextField } from "@/common/components/UnitTextField"
import {Dispatch, KeyboardEvent, SetStateAction, useState} from "react"
import PaginationButton from "../../paginationButton"

interface InputSearchPaginationProps {
  setPage: Dispatch<SetStateAction<number | undefined>>
  totalPages: number
  setSearchPage: Dispatch<SetStateAction<boolean>>
  searchPage: boolean
}

export default function InputSearchPagination({
  setPage,
  totalPages,
  setSearchPage,
  searchPage
}: InputSearchPaginationProps) {
  const [inputSearchPageValue, setInputSearchPageValue] = useState('')

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
    const currentValue = Number(e.currentTarget.value);

    const pageNumber = currentValue 
      ? currentValue > totalPages 
        ? totalPages 
        : currentValue
      : undefined

    if(pageNumber) {
      switch (e.key) {
        case 'Enter':
          const targetPage = pageNumber > 1 ? pageNumber : undefined

          setPage(targetPage);
          setInputSearchPageValue('')
          setSearchPage(false)
        break;
        case 'Escape':
          setInputSearchPageValue('')
          setSearchPage(false)
        break;
      }
    }
  }

  if(searchPage) {
    return (
      <UnitTextField
        unit=''
        onBlur={() => {
          setSearchPage(false)
          setInputSearchPageValue('')
        }}
        onKeyDown={handleKeyDown}
        value={inputSearchPageValue}
        autoFocus
        onChange={(e) => setInputSearchPageValue((e.target as HTMLInputElement).value)}
        variant='pagination'
        decimals={0}
      />
    )
  }

  return (
    <PaginationButton
      onClick={() => setSearchPage(true)} 
      className='hover:underline'
    >
      ....
    </PaginationButton>
  )
}